import gql from 'graphql-tag';

export const accountCapabilitiesFragment = gql`
  fragment accountCapabilitiesFragment on AccountCapabilities {
    dokkioClass
    canEdit
    canCreateDokkioUser
    canCreateDokkioLabel
  }
`;
export default accountCapabilitiesFragment;
